import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import en from "../assets/translateResources/en";
import uk from "../assets/translateResources/uk";

const resources = {
  en: {
    translation: en,
  },
  uk: {
    translation: uk,
  },
};

i18n.use(initReactI18next).init({
  resources,
  lng: localStorage.getItem("lng") || "uk",
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
